import React from "react";
import { I18n } from "../../../../models/I18n";
import ReportSummarySection from "../ReportSummarySection/ReportSummarySection";
import { ReportSummaryColors } from "../../constants/ReportSummaryColors";
import style from "./style/ListSummary.module.scss";

export interface ListSummaryProps {
    title: string;
    handle: string;
    basedOn: string;
    circleColor?: ReportSummaryColors;
    showViewAll: boolean;
    scrollToSection?: (elementId: string) => void;
    i18n: I18n;
    classes?: { titleDecoration: string; }
}

const ListSummary = ({
    title,
    handle,
    basedOn,
    circleColor = ReportSummaryColors.LIGHTBLUE,
    showViewAll,
    scrollToSection,
    children,
    i18n,
    classes,
}: React.PropsWithChildren<ListSummaryProps>) => {
    return (
        <div className={style.listSummaryWrapper}>
            <ReportSummarySection
                basedOn={basedOn}
                handle={handle}
                i18n={i18n}
                scrollToSection={scrollToSection ? scrollToSection : null}
                showViewAll={showViewAll}
                title={title}
                classes={classes || { titleDecoration: "" }}
            >
                <div
                    className={style.list}
                    style={
                        {
                            "--list-circle-color": circleColor,
                        } as React.CSSProperties
                    }
                >
                    {children}
                </div>
            </ReportSummarySection>
        </div>
    );
};

export default ListSummary;
